// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6e165e8","453":"4cdd3af0","732":"d77f7e68","977":"51734523"}[chunkId] + ".chunk.js";
};